/**
 * Canonical `attendanceLabel` values from `dw.bh_appointment_member` / `appointments.appointment`.
 */
export enum BhAppointmentAttendanceLabel {
  Attended = 'Attended',
  NotAttended = 'Not Attended',
  FutureAppointment = 'Future Appointment',
  Unknown = 'Unknown',
}
